import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Row from 'antd/lib/row'
import 'antd/lib/row/style/css'

import './RowComponent.scss'

const RowComponent = (props) => {
  const { debug, className } = props

  const classes = classnames('row-component', { debug }, className)

  return <Row {...props} className={classes} />
}

RowComponent.propTypes = {
  debug: PropTypes.bool,
  gutter: PropTypes.number,
  className: PropTypes.string,
}

export default RowComponent
